import { LazyImport, LazyModule } from 'owa-bundling';

export { default as AttachmentDataProvider } from 'owa-service/lib/contract/AttachmentDataProvider';
export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';
export { default as FileProviderStore } from './store/schema/FileProviderStore';
export { default as FileProviderViewState } from './store/schema/FileProviderViewState';
export { default as FileSelectionFilter } from './store/schema/FileSelectionFilter';
export { default as getProviderBrandName } from './utils/getProviderBrandName';
export { default as getStore } from './store/store';
export {
    fileProviderAdded,
    fileProviderRemoved,
    providersLoaded,
} from './actions/subscribableActions';
export {
    ClientOnlyFileProviderType,
    FileProviderType,
    FileProviderViewType,
} from './utils/constants';
export { getAddedFileProviders } from './selectors/getAddedFileProviders';
export { getFileProviders } from './selectors/getFileProviders';
export { getProviderLoadState } from './selectors/getProviderLoadState';
export { ProviderLoadStateOption } from './store/schema/ProviderLoadStateOption';
export {
    default as AddableFileProviderInfo,
    getAddableFileProviderInfo,
    createAddableFileProviderInfo,
} from 'owa-add-fileprovider/lib/utils/AddableFileProviderInfo';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FileProviderStore", webpackPrefetch: true */ './lazyIndex')
);

// Delayed loaded imports
export const lazyLoadProviders = new LazyImport(lazyModule, m => m.loadProviders);
export const lazyRemoveFileProvider = new LazyImport(lazyModule, m => m.removeFileProvider);
export const lazyAddFileProvider = new LazyImport(lazyModule, m => m.addFileProvider);
export const lazyRemoveAndAddFileProvider = new LazyImport(
    lazyModule,
    m => m.removeAndAddFileProvider
);
